import { gql, LazyQueryHookOptions, useLazyQuery } from '@apollo/client';
import {
  GetLicenseInfoQuery,
  GetLicenseInfoQueryVariables,
} from '../../../shared/generated/graphql';

/* eslint-disable graphql/template-strings */
export const GET_LICENSE = gql`
  query getLicenseInfo {
    getLicenseInfo {
      end
      expired
      federation_type
      gbps
      input_region
      license_type
      members {
        display_name
        tenant_id
      }
      org
      primary_contact {
        email
        name
      }
      retention_days
      start
      tenant
      tenant_location
      tenant_type
      display_name
      system_info {
        humio_root
      }
    }
  }
`;
/* eslint-enable graphql/template-strings */

export const useGetLicenseInfo = (
  options?: LazyQueryHookOptions<
    GetLicenseInfoQuery,
    GetLicenseInfoQueryVariables
  >,
) => {
  return useLazyQuery<GetLicenseInfoQuery, GetLicenseInfoQueryVariables>(
    GET_LICENSE,
    options,
  );
};
